import Button from '@material-ui/core/Button';
import Container from "@material-ui/core/Container";
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import React from "react";
import { JsonToTable } from "react-json-to-table";

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflow: 'scroll'
    },
    jsonTable: {
        '& table': { tableLayout: 'fixed' },
        '& td': { wordWrap: 'break-word' }
    }
}));

export default function Details(props) {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleOpen}>
                Детали
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={handleClose}
                className={classes.modal}
            >
                <div className={classes.paper}>
                    <h2>Событие {props.data[2]} в блоке {props.data[0]}</h2>
                    <h4>Транзакция: <br/>{props.data[1]}</h4>
                    <Container className={classes.jsonTable} maxWidth="lg">
                        <JsonToTable json={props.data[3]}/>
                    </Container>
                </div>
            </Modal>
        </div >
    );
}